<template>
  <n-card
    class="recurrent-intervention-card"
    :class="{ clickable: isClickable }"
    @click="$emit(`click`, value)"
  >
    <v-row no-gutters justify="start" align="center" class="recurrent-intervention-recurrence" v-if="hasRecurrenceInfos">
      <v-icon small class="mr-1">repeat</v-icon>
      {{ recurrentIntervention | formatInterventionRecurrence }}
      <v-spacer />
      <v-icon small class="mr-1">skip_next</v-icon>
      Prochaine éxécution le {{ recurrentIntervention.nextAt | formatDate }}
    </v-row>
    <v-row no-gutters justify="start" align="center" class="recurrent-intervention-recurrence" v-else>
      <v-icon small class="mr-1">play_arrow</v-icon>
      Proposée le {{ recurrentIntervention.createdAt | formatDate }}
      <v-spacer />
    </v-row>
    <v-row no-gutters class="recurrent-intervention-header">
      <v-col class="d-flex flex-column header">
        <div>
          <div class="description">
            <v-clamp autoresize :max-lines="2">
              {{ recurrentIntervention.title }}
            </v-clamp>
          </div>
        </div>
        <v-spacer></v-spacer>
        <div>
          <v-row no-gutters>
            <v-col class="site ellipsis mr-2">
              <v-icon small>business</v-icon>
              {{ recurrentIntervention.site.name }}
            </v-col>
            <div class="address" v-if="recurrentIntervention.$address.length">
              {{ recurrentIntervention.$address }}
              <v-icon small>place</v-icon>
            </div>
          </v-row>
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters class="recurrent-intervention-footer">
      <v-col class="footer-item client">
        <div class="footer-item-title ellipsis">client</div>
        <div class="footer-item-content ellipsis">{{ recurrentIntervention.client.name }}</div>
      </v-col>
      <v-col class="footer-item domain">
        <div>
          <div class="footer-item-title ellipsis">domaine</div>
          <div class="footer-item-content ellipsis">{{ recurrentIntervention.domain.name }}</div>
        </div>
      </v-col>
      <v-col class="footer-item priority">
        <div>
          <div class="footer-item-title ellipsis">priorité</div>
          <div class="footer-item-content ellipsis">{{ recurrentIntervention.priority.name }}</div>
        </div>
      </v-col>
      <v-col class="footer-item indicators-wrapper align-self-stretch">
        <div class="indicators">
          <v-row no-gutters align="center" justify="center">
            <div class="indicator-item">
              <v-icon>memory</v-icon>
              <div class="indicator-number">{{ recurrentIntervention.equipments.length }}</div>
            </div>
          </v-row>
        </div>
      </v-col>
    </v-row>
    <v-row
      no-gutters
      justify="end"
      align="center"
      class="px-2 py-1 recurrent-intervention-tags"
      v-if="hasTags"
    >
      <div>
        <tag-chip
          v-for="tag in recurrentIntervention.makerTags"
          :key="`tag-${tag.id}`"
          :tag="tag"
          :removable="canRemoveTag"
          @remove="removeMakerTag(tag)"
        />
      </div>
    </v-row>
  </n-card>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    clickable: Boolean,
  },

  data: () => ({
    canRemoveTag: false,
    isShowingTagsList: false,
  }),

  computed: {
    ...mapState(`model/user`, [
      `isAdmin`,
    ]),
    isClickable() {
      return this.clickable === true;
    },
    recurrentIntervention() {
      return {
        ...this.value,
        makerTags: [],
        $address: _.trim(`${this.value.site.address || ``} ${this.value.site.postalCode || ``} ${this.value.site.city || ``}`).replace(/ +/g, ` `),
      };
    },
    hasRecurrenceInfos() {
      return !_.isUndefined(this.recurrentIntervention.recurrenceType);
    },
    hasTags() {
      return Boolean(this.recurrentIntervention.makerTags.length > 0);
    },
    canAddTag() {
      return Boolean(this.isAdmin);
    },
  },

  methods: {
    async tagSelected(tag) {
      this.isShowingTagsList = false;
      this.$emit(`tag-added`, tag);
    },
  },
};
</script>

<style lang="scss">
.recurrent-intervention-card {
  .recurrent-intervention-recurrence {
    background-color: #e7e8ff;
    border-bottom: 1px solid #E2E2E2;
    padding: 4px 12px 3px;
    font-size: 0.9rem;
    font-weight: 500;
  }
  .recurrent-intervention-header {
    padding-top: 10px;
    padding-bottom: 4px;
    border-bottom: 1px solid #E2E2E2;
  }
  .header {
    margin-left: 15px;
    margin-right: 15px;
    min-height: 72px;
    .description {
      margin-right: 40px;
      text-align: left;
      font-size: 1.1rem;
      font-weight: 700;
      line-height: 1.5rem;
    }
    .more {
      margin-top: -5px;
    }
    .address,
    .site {
      font-size: 0.8rem;
      text-align: left;
      .v-icon {
        color: $primaryColor;
        margin-top: -4px;
        margin-right: 0px;
      }
    }
    .address,
    .site {
      .v-icon {
        color: $secondaryColor;
      }
    }
    .time-infos {
      font-style: italic;
      text-align: right;
      font-size: 0.8rem;
      padding-right: 3px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  &.challenging-intervention .header {
    margin-left: 10px;
  }

  .recurrent-intervention-footer {
    margin: 0px 1px 1px;
  }

  .footer-item {
    min-width: 0;
    text-align: left;
    margin: 0px;
    background-color: transparent;
    &, &.col {
      padding: 8px;
    }
    &:not(:first-of-type) {
      border-left: 1px solid #E2E2E2;
    }
    .footer-item-title {
      font-size: 0.8rem;
      color: #888;
    }
    .footer-item-content {
      font-weight: 500;
      color: #111;
    }
    &.updated-at {
      min-width: 172px;
    }
    &.date {
      max-width: 130px;
    }
    &.indicators-wrapper {
      max-width: 120px;
      .indicators {
        height: 100%;
        & > .row {
          height: 100%;
        }
      }
      .indicator-item {
        &:not(:last-child) {
          margin-right: 14px;
        }
        .v-icon {
          margin-top: -1px;
          font-size: 1rem;
          margin-right: 3px;
          opacity: .6;
        }
      }
      .indicator-number {
        display: inline-block;
        font-size: 1rem;
        font-weight: 500;
        color: #111;
      }
    }
  }

  .recurrent-intervention-tags {
    border-top: 1px solid #E2E2E2;
  }
}
</style>
